export * from '@cipafacil/services/media-watcher/public-api';
